// extracted by mini-css-extract-plugin
export var layoutContainer = "_9g-0";
export var layoutContainerNoRounding = "_9g-6";
export var layoutContainerOpen = "_9g-5";
export var layoutContainerResizing = "_9g-1";
export var mainContent = "_9g-2";
export var resizeDivider = "_9g-3";
export var slidePanel = "_9g-4";